import React from "react";
import {p0, p1, p2, p4, p8, p16, p32} from "../../pl_commons";
import PlIcon from "../pl_icon";
import {baseline, baseline_turn, baseline_turn2, bm_left, bm_right, bm_turn, bm_turn2} from "./icon_commons";
import {is_bus_available} from "./plan_commons";

const TkIcon = ({item}) => {

    const avail = is_bus_available(item)

    var rtcolor = '#777777';
    if (!item.fbaddr) {
        rtcolor = '#174b0c'
    }

    let bmstate = item.fbstat === "true"
    let bmlcid = item.bmlc > 0 ? item.bmlc : ""
    let inroute = item.lockdir === "east" || item.lockdir === "west"

    if (inroute) {
        rtcolor = '#fff44f';
    }

    if( item.bm_route_only && bmstate && inroute) {
        rtcolor = '#ff0000';
    } else if( bmstate && !item.bm_route_only ) {
        rtcolor = '#ff0000';
    }


    let lines = [];
    let transform = "rotate(0,0,0)";
    if (item.subtype === "curve" || item.subtype === "doublecurve") {

        lines.push(baseline_turn());
        lines.push(bm_turn({stroke: rtcolor}));

        if( item.subtype === "doublecurve") {
            lines.push(baseline_turn2())
            lines.push(bm_turn2({stroke: rtcolor}))
        }

        if (item.ori === "west") {
            transform = "rotate(270,0,0)";
        } else if (item.ori === "east") {
            transform = "rotate(90,0,0)";
        } else if (item.ori === "south") {
            transform = "rotate(0,0,0)";
        } else if (item.ori === "north") {
            transform = "rotate(180,0,0)";
        }

    } else {
        if (item.subtype === "buffer") {
            lines.push(<line key="l1" x1={p2} y1={p2} x2={p1} y2={p2} strokeWidth={p8} stroke="#000000"
                             strokeLinecap="butt"/>);
            lines.push(<line key="l2" x1={p2 + p8} y1={p2} x2={p1 - p8} y2={p2} strokeWidth={p16} stroke={rtcolor}
                             strokeLinecap="butt"/>);

            lines.push(<line key="l5" x1={p2} y1={p0 + p4} x2={p2} y2={p1 - p4} strokeWidth={p8} stroke="#000000"
                             strokeLinecap="butt"/>);

        } else if (item.subtype === "connector") {
            // if (item.ori === "east") {
            lines.push(<line key="l1" x1={p2} y1={p2} x2={p1} y2={p2} strokeWidth={p8} stroke="#000000"
                             strokeLinecap="butt"/>);
            lines.push(<line key="l2" x1={p2 + p16} y1={p2} x2={p1 - p16} y2={p2} strokeWidth={p16} stroke={rtcolor}
                             strokeLinecap="butt"/>);
            lines.push(<line key="l6" x1={p2 - p8 + p16} y1={p0 + p4} x2={p2 - p8 - p16} y2={p1 - p4}
                             strokeWidth={p32} stroke="#000000"
                             strokeLinecap="butt"/>);
            lines.push(<line key="l5" x1={p2 + p16} y1={p0 + p4} x2={p2 - p16} y2={p1 - p4} strokeWidth={p32}
                             stroke="#000000"
                             strokeLinecap="butt"/>);
        } else {
            lines.push(baseline());
            lines.push(bm_left({stroke: rtcolor}));
            lines.push(bm_right({stroke: rtcolor}));
        }

        if (item.ori === "west") {
            transform = "rotate(180,0,0)";
        } else if (item.ori === "east") {
            transform = "rotate(0,0,0)";
        }
    }

    return (
        <PlIcon item={item} transform={transform}>
            {lines}
        </PlIcon>
    )

}

export default TkIcon